import isSmimeAdapterUsable from 'owa-smime-adapter/lib/utils/isSmimeAdapterUsable';
import SmimeResult from 'owa-smime-adapter/lib/store/schema/SmimeResult';
import SmimeErrorStateEnum from 'owa-smime-adapter/lib/store/schema/SmimeErrorStateEnum';
import ISmimeAdapter from 'owa-smime-adapter/lib/adapter/ISmimeAdapter';
import SmimeCustomError from './SmimeCustomError';
import SmimeContext from '../store/schema/SmimeContext';
import { getStore } from 'owa-smime-adapter/lib/store/store';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

export default async function getSigningCertificate(smimeAdapter: ISmimeAdapter): Promise<string> {
    const { SmimeAdminSettings, UserOptions } = getUserConfiguration();
    let subjectKeyIdentifier;
    if (
        SmimeAdminSettings.AllowUserChoiceOfSigningCertificate &&
        UserOptions.ManuallyPickCertificate
    ) {
        subjectKeyIdentifier = UserOptions.SigningCertificateId;
    } else {
        subjectKeyIdentifier = null;
    }

    if (isSmimeAdapterUsable()) {
        const signingCertResponseJson: SmimeResult = await smimeAdapter.getSigningCertificateAsync(
            subjectKeyIdentifier
        );
        if (signingCertResponseJson.ErrorCode == SmimeErrorStateEnum.NoError) {
            return signingCertResponseJson.Data as string;
        } else {
            throw new SmimeCustomError(
                'S/MIME: Unable to retrieve signing certificate',
                signingCertResponseJson.ErrorCode,
                SmimeContext.SigningMessage
            );
        }
    } else {
        throw new SmimeCustomError(
            'S/MIME: Adapter is not usable. Installation Status: ' + getStore().installationStatus,
            SmimeErrorStateEnum.ControlError,
            SmimeContext.Unspecified
        );
    }
}
